import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Fnn: React.FC = () => (
  <div style={{
    minHeight: '100vh',
    background: '#0a0a0a',
    color: '#222',
    fontFamily: "'Inter', Arial, Helvetica, sans-serif",
    display: 'flex',
    flexDirection: 'column'
  }}>
    <Header />
    <main style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }}>
      <div style={{
        maxWidth: 900,
        width: '100%',
        margin: '40px auto',
        background: '#fff',
        padding: 32,
        borderRadius: 8,
        boxSizing: 'border-box',
        boxShadow: '0 2px 12px rgba(0,0,0,0.07)'
      }}>
        <div style={{ color: '#0a3d62', fontWeight: 700, fontSize: '1.05em', letterSpacing: 1, marginBottom: 8 }}>
          Cidades • Meio Ambiente
        </div>
        <h1 style={{ color: '#0a3d62', marginTop: 0, marginBottom: 8 }}>
          Empresa acionada emergencialmente em Belém já foi investigada por fraude e ligação com crime organizado
        </h1>
        <div style={{ color: '#888', fontSize: '0.95em', marginBottom: 24 }}>
          Histórico da companhia inclui suspeitas de conluio em licitações e participação em esquemas criminosos, segundo investigações da Polícia Federal e Ministério Público.<br />
          Belém (PA), 09 de outubro de 2025 • Atualizado em 09/10/2025 15:20
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src="/images/logo/fnn.jpg"
            alt="Déchets toxiques à Belém"
            style={{
              width: '100%',
              maxWidth: 700,
              borderRadius: 8,
              margin: '20px 0'
            }}
          />
        </div>
        <p>
          Após a interdição da empresa Lev Descarte pelo Ministério Público, hotéis e empresas em Belém enfrentam um impasse para manter a coleta de resíduos. A solução emergencial encontrada por alguns gestores foi acionar o único outro prestador disponível na região. No entanto, essa empresa possui um histórico preocupante.
        </p>
        <p>
          De acordo com investigações do Ministério Público do Pará, a companhia esteve envolvida em fraudes em licitações e esquemas de lavagem de dinheiro no setor de limpeza urbana. A Operação Entulho, deflagrada em 2023, revelou que empresas do ramo utilizaram notas fiscais frias e empresas de fachada para desviar recursos e reduzir bases tributárias, movimentando valores que ultrapassaram R$ 245 milhões entre 2016 e 2021 (PF/Receita/MPF; AM Post).
        </p>
        <p>
          Além disso, relatórios e decisões judiciais apontam indícios de associação com organizações criminosas para garantir contratos públicos, com práticas como direcionamento de concorrências e pagamento de propinas a agentes públicos — conjuntura semelhante à revelada em apurações recentes sobre o setor de limpeza urbana no país (iG Último Segundo).
        </p>
        <p>
          Em Belém, processos licitatórios de grande porte para a limpeza urbana foram suspensos pelo Tribunal de Contas dos Municípios e pelo Judiciário em razão de irregularidades, incluindo ausência de projeto básico e indícios de conluio entre participantes (DOL; g1 Pará; O Liberal).
        </p>
        <p>
          Especialistas consultados alertam que a nova prestadora além de atuar com a prefeitura, também irá atuar com a rede hoteleira de Belém como Accor, Radisson e Bristol. A contratação em rede privada com a nova prestadora, sem a devida diligência, pode expor empresas e hotéis a riscos legais, reputacionais e até criminais. A recomendação é adotar medidas de contingência, auditoria independente do ciclo de resíduos e revisão imediata de contratos e fornecedores.
        </p>
        <div style={{
          background: '#eaf6fb',
          borderRadius: 6,
          padding: 18,
          margin: '32px 0',
          color: '#0a3d62',
          fontWeight: 500,
          fontSize: '1.1em'
        }}>
          <b>Nota de redação:</b> As informações sobre investigações citadas nesta reportagem referem-se a documentos e notícias públicas. Todas as pessoas e empresas mencionadas gozam da presunção de inocência até decisão transitada em julgado. O veículo mantém aberto o espaço para direito de resposta e atualização de posicionamentos.
        </div>
        <div style={{ marginBottom: 24 }}>
          <b>Referências:</b>
          <ul style={{ marginTop: 8, marginBottom: 8, color: '#444', fontSize: '0.98em' }}>
            <li><a target="_blank" href='https://www.brasil247.com/brasil/operacao-da-pf-combate-fraudes-de-empresas-de-coleta-de-lixo-e-limpeza-publica'>Operação Entulho (PF/RFB/MPF) – cobertura</a></li>
            <li><a target="_blank" href='https://ampost.com.br/policia/pf-investiga-esquema-de-fraude-em-empresas-de-coleta-de-lixo-que-desviou-r-245-milhoes-em-manaus/'>PF investiga fraudes no setor de coleta de lixo – AM Post</a></li>
            <li><a target="_blank" href='https://imediatoonline.com/cidade/mais-de-30-empresas-de-coletas-de-lixo-e-limpeza-publica-sao-alvos-da-pf-mp-e-receita-federal/'>Mais de 30 empresas do setor são alvos – Imediato Online</a></li>
            <li><a target="_blank" href='https://dol.com.br/noticias/para/825695/licitacao-bilionaria-do-lixo-em-belem-e-suspensa?d=1'>Licitação do lixo em Belém suspensa – DOL</a></li>
            <li><a target="_blank" href='https://g1.globo.com/pa/para/noticia/2023/08/01/lixo-em-belem-tcm-notifica-prefeitura-e-sesan-apos-receber-denuncia-de-possiveis-irregularidades-na-licitacao.ghtml'>TCM-PA notifica Prefeitura – g1 Pará</a></li>
            <li><a target="_blank" href='https://www.oliberal.com/belem/tribunal-de-contas-dos-municipios-recebe-nova-denuncia-contra-licitacao-para-coleta-de-lixo-em-belem-1.722878'>Nova denúncia no TCM – O Liberal</a></li>
            <li><a target="_blank" href='https://g1.globo.com/pa/para/noticia/2025/02/26/empresa-suspende-coleta-de-entulhos-apos-trabalhadores-serem-mantidos-refens-na-grande-belem.ghtml'>Cenário de violência no Aurá – g1 Pará</a></li>
          </ul>
        </div>
        <div style={{
          background: '#f7f7f7',
          borderRadius: 6,
          padding: 18,
          margin: '32px 0',
          color: '#0a3d62',
          fontWeight: 500,
          fontSize: '1.05em'
        }}>
          <b>Linha do Tempo</b><br />
          Crise da limpeza urbana em Belém
          <ul style={{ marginTop: 8, marginBottom: 0, color: '#444', fontSize: '0.98em' }}>
            <li><b>2023</b> – Operação Entulho expõe fraudes no setor (PF, RFB e MPF).</li>
            <li><b>2023</b> – Licitações da limpeza urbana em Belém são questionadas e suspensas (TCM-PA e Justiça).</li>
            <li><b>2024</b> – Crescem denúncias públicas de greenwashing e irregularidades na destinação de resíduos.</li>
            <li><b>2025</b> – MP interdita Lev Descarte; hotéis acionam prestador com histórico de investigações.</li>
          </ul>
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default Fnn;